import { ReactElement } from "react";
import styles from "rivals/components/shared/Icons/Icons.module.scss";
import type { IconProps } from "./iconPropsTypes";

const SearchIcon = ({ fill }: IconProps): ReactElement => (
  <svg fill="none" viewBox="0 0 54 54" xmlns="http://www.w3.org/2000/svg">
    <path
      clipRule="evenodd"
      d="M20.5 41C9.17816 41 0 31.8218 0 20.5C0 9.17816 9.17816 0 20.5 0C31.8218 0 41 9.17816 41 20.5C41 24.9437 39.5861 29.0572 37.1837 32.4151L54 49.2314L49.2314 54L32.4151 37.1837C29.0572 39.5861 24.9437 41 20.5 41ZM20.5 34C27.9558 34 34 27.9558 34 20.5C34 13.0442 27.9558 7 20.5 7C13.0442 7 7 13.0442 7 20.5C7 27.9558 13.0442 34 20.5 34Z"
      fill={fill || styles.white}
      fillRule="evenodd"
    />
  </svg>
);

export default SearchIcon;
